// router/index.js — Vue Router 4

import { createRouter, createWebHistory } from 'vue-router'

import Homepage from '../views/Homepage.vue'
import Career from '../views/Career.vue'
import Blog from '../views/Blog.vue'
import Layout from '../Layout.vue'
import Article from '../components/Blog/Article.vue'
import Success from '../components/Success.vue'
import Contacts from '../views/Contacts.vue'
import Privacy from '../views/Privacy.vue'

import BackendLayout from '@/views/backend/BackendLayout.vue'
import BackendEditor from '@/views/backend/BackendEditor.vue'
import CreateArticle from '@/views/backend/editors/Article.vue'
import EditArticle from '@/views/backend/editors/Article.vue'
import Login from '@/views/backend/Login.vue'
import FAQ from '@/views/FAQ.vue'

const routes = [
  { path: '/', redirect: '/pt' },

  // Backend (/:lang/backend/...)
  {
    path: '/:lang/backend',
    component: BackendLayout,
    children: [
      { path: 'login', name: 'backend-login', component: Login },
      { path: '', name: 'backend-root', component: BackendEditor },
      { path: 'create', name: 'backend-create-article', component: CreateArticle },
      { path: ':article_id', name: 'backend-edit-article', component: EditArticle }
    ]
  },

  // Frontend (/:lang/...)
  {
    path: '/:lang',
    component: Layout,
    children: [
      { path: '', name: 'home', component: Homepage },
      { path: 'home', name: 'home-alias', component: Homepage },
      { path: 'home/:place', name: 'home-place', component: Homepage },
      { path: 'career', name: 'career', component: Career },
      { path: 'blog', name: 'blog', component: Blog },
      { path: 'blog/article/:id', name: 'blog-article', component: Article },
      { path: 'success', name: 'success', component: Success },
      { path: 'faq', name: 'faq', component: FAQ },
      { path: 'contacts', name: 'contacts', component: Contacts },
      { path: 'privacy', name: 'privacy', component: Privacy },

      // redirect antigo /article/:id -> /:lang/blog/article/:id
      {
        path: 'article/:id',
        redirect: to => ({
          name: 'blog-article',
          params: { lang: to.params.lang, id: to.params.id }
        })
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL || '/'),
  routes
})

export default router
